// extracted by mini-css-extract-plugin
export default {"row":"_2WYTx _1brkc","minimal":"_1JcaK","isWeapons":"_3nUZ8","mod":"_2I5MA","info":"_35diU","name":"_3sBrL"};